import { serviceGo } from '@/utils/request'

// 小说数据看板：按「初始小说」把新用户分组，一本书一行，看这批用户的发消息 / 消费果肉分层表现。
// 口径与「初始小说新增数据」页同源（同一套注册窗口 + 渠道 + 版本 + 1.0.16 手机号规则），
// 所以本页的 new_users 等于那页选中该书后「初始用户」列头的人数。
export interface NovelDataParams {
  n_days: 0 | 1 | 3 | 7 | 14 | 30  // 注册当天为第 0 日，N 日内 = 第 0…N 日
  start_date: string               // 注册日期范围起（yyyy-MM-dd，北京时间，闭区间）
  end_date: string                 // 注册日期范围止
  channel: 'toutiao' | 'kuaishou' | 'other' | 'all'
  version: string                  // 版本筛选（如 '1.0.16'）
  version_mode: 'gte' | 'eq'       // gte=该版本及之后 | eq=仅该版本
}

// 四组指标下发的都是**分子人数**（不是百分比），率由前端算，便于同时展示百分比和「分子/分母 人」。
// 数组下标与 meta 里的阈值一一对应。
export interface NovelDataRow {
  game_id: number
  title: string
  new_users: number   // 以该书为初始小说的新用户数 = 所有率的分母
  msg_any: number[]   // 在任意小说里发消息条数 ≥ 各阈值的人数
  msg_book: number[]  // 在该小说里发消息条数 ≥ 各阈值的人数
  pay_any: number[]   // 在任意小说里消费果肉 ≥ 各阈值的人数
  pay_book: number[]  // 在该小说里消费果肉 ≥ 各阈值的人数
}

// 阈值随数据下发，表头据此渲染，不在前端写死——后端改阈值这里自动跟上
export interface NovelDataMeta {
  msg_thresholds: number[]
  pay_thresholds: number[]
}

export interface NovelDataResp {
  rows: NovelDataRow[]
  meta: NovelDataMeta
}

// 拉取小说数据（Go 后端，需管理员权限）。按新用户数降序，只含该窗口内确实有初始用户的书。
export async function getNovelData(params: NovelDataParams): Promise<NovelDataResp> {
  const res = await serviceGo.get('/api_v2/admin/novel-data', { params })
  return res.data.data
}

// 导出小说数据为 Excel。参数与 getNovelData 完全一致——后端用同一份计算装配工作簿，
// 所以导出的数字和页面上看到的一定相同（不是导出时另算一遍）。
// 返回整个 axios 响应而不是 res.data：文件名要从 Content-Disposition 头里取。
export function exportNovelData(params: NovelDataParams) {
  return serviceGo.get('/api_v2/admin/novel-data/export', {
    params,
    responseType: 'blob'
  })
}
